// cSpell:ignore oppervlakte OPPERVLAKTE Verdeling VERDELING VOLGENS volgens
// An apportionment key's name as a sentence or a list shows it (Lewis,
// 2026-10-17): as the broker stored it, never set in capitals by the
// screen. A name stored in capitals ("VERDELING VOLGENS OPPERVLAKTE") reads
// as shouting in a sentence, so it is shown in sentence case ("Verdeling
// volgens oppervlakte"); a short one ("VME") is an abbreviation and stays.

const MIN_SHOUTED_LETTERS = 4;
const LOCALE = "nl";

export const keyDisplayName = (name: string): string => {
  const letters = name.replace(/[^\p{L}]/gu, "");
  const isShouted =
    letters.length >= MIN_SHOUTED_LETTERS &&
    letters === letters.toLocaleUpperCase(LOCALE) &&
    letters !== letters.toLocaleLowerCase(LOCALE);
  if (!isShouted) return name;
  const lower = name.toLocaleLowerCase(LOCALE);
  return lower.charAt(0).toLocaleUpperCase(LOCALE) + lower.slice(1);
};
